import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {
  IShoppingCartItem,
  SessionSearch,
} from '../../components/session-search/types/SessionSearch';

interface SessionSearchState {
  persistentSearches: SessionSearch[];
  shoppingCartItems: IShoppingCartItem[];
}

const initialState: SessionSearchState = {
  persistentSearches: [],
  shoppingCartItems: [],
};

export const sessionSearchSlice = createSlice({
  name: 'sessionSearch',
  initialState,
  reducers: {
    AddUnsavedSearch: (state, action: PayloadAction<SessionSearch>) => {
      const existingIndex = state.persistentSearches.findIndex(
        (s) => s.id === action.payload.id
      );

      const payloadCopy = {...action.payload};

      if (existingIndex !== -1) {
        state.persistentSearches[existingIndex] = payloadCopy;
      } else {
        state.persistentSearches.unshift(payloadCopy);
      }
    },
    PersistSearches: (state, action: PayloadAction<SessionSearch[]>) => {
      state.persistentSearches = action.payload;
    },
    AddToShoppingCart: (state, action: PayloadAction<IShoppingCartItem>) => {
      const payloadCopy = {...action.payload};
      state.shoppingCartItems.push(payloadCopy);
    },
    RemoveFromShoppingCart: (
      state,
      action: PayloadAction<IShoppingCartItem>
    ) => {
      state.shoppingCartItems = state.shoppingCartItems.filter(
        (x) => !(x.id === action.payload.id && x.type === action.payload.type)
      );
    },
    ClearShoppingCart: (state) => { state.shoppingCartItems = []; },
  },
});

export const {
  AddUnsavedSearch,
  PersistSearches,
  AddToShoppingCart,
  RemoveFromShoppingCart,
  ClearShoppingCart
} = sessionSearchSlice.actions;
export default sessionSearchSlice.reducer;
